import { render, staticRenderFns } from "./SurveyQuestionEditor.vue?vue&type=template&id=75d70689&scoped=true"
import script from "./SurveyQuestionEditor.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d70689",
  null
  
)

export default component.exports